const state = {
    prioritySet: null,
    prioritySetMasterList: [],
    prioritySetMasterTotal: 0

}

const mutations = {
    SET_PRIORITY_SET(state, data){
        state.prioritySet = data;
        if(state.prioritySet.priority_options == null){
            state.prioritySet.priority_options = [];
        }else{
            state.prioritySet.priority_options = JSON.parse(data.priority_options);
        }
    },
    SET_PRIORITY_SET_MASTER_LIST(state, data){
        state.prioritySetMasterTotal = data.total;
        data = data.items;
        data.forEach(function(el, index){
            if(el.priority_options == null){
                data[index].priority_options = [];
            }else{
                data[index].priority_options = JSON.parse(data[index].priority_options);
            }
        })
        state.prioritySetMasterList = data;

    }
}

const actions = {
    getPrioritySet({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/contracts/` + params.contract_id +`/priority-set`)
                .then(response => {
                    commit('SET_PRIORITY_SET', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    getPrioritySetMasterList({commit}, params){
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || { is_master: true };
        return new Promise((resolve, reject) => {
            global.axios.get(`api/priority-set`, {
                params:{
                  page:page,
                  limit:limit,
                  filter:filter
                }
            })
            .then(response => {
                commit('SET_PRIORITY_SET_MASTER_LIST', response.data.data);
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    updatePrioritySet({commit}, params){
        return new Promise((resolve, reject) => {
            global.axios.put(`api/priority-set/` + params.id, {
                priority_title: params.priority_title,
                is_master: params.is_master,
                priority_options: JSON.stringify(params.priority_options)
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    createPrioritySet({commit}, params){
        return new Promise((resolve, reject) => {
            global.axios.post(`api/priority-set/`, {
                priority_title: params.priority_title,
                is_master: params.is_master,
                priority_options: JSON.stringify(params.priority_options)
            })
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => reject(error));
        });
    },
    deletePriorityMasterSet({commit}, ids){
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/priority-set`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    }

}

const getters = {
    prioritySet: state => state.prioritySet,
    prioritySetMasterList: state => state.prioritySetMasterList,
    prioritySetMasterTotal: state => state.prioritySetMasterTotal
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
